/**
 * La marque : un centre plein, son cercle, un satellite creusé, et un satellite en pointillé
 * — jamais ouvert, et en ambre parce qu'il attend le monde. Toute la thèse en 42 pixels.
 */
export function Marque({ taille = 42 }: { taille?: number }) {
  return (
    <svg
      width={taille}
      height={taille}
      viewBox="0 0 42 42"
      fill="none"
      role="img"
      aria-label="Nextilt"
    >
      <circle cx="21" cy="21" r="14" stroke="var(--accent)" strokeWidth="1.6" />
      <circle cx="21" cy="21" r="4.6" fill="var(--accent)" />
      <circle cx="35.5" cy="10.5" r="4" stroke="var(--accent)" strokeWidth="1.5" />
      <circle
        cx="7"
        cy="32"
        r="3.2"
        stroke="var(--monde)"
        strokeWidth="1.5"
        strokeDasharray="2 2.4"
      />
    </svg>
  );
}
